import request from './../request.js'
export function getOperatorInterfaceList(params) {//获取
    return request({
        url: "/account/accountInterface/getList.do?",
        method: 'post',
        data: params
    })
}
export function addOperatorInterface(params) {//新增
    return request({
        url: "/account/accountInterface/insert.do?",
        method: 'post',
        data: params
    })
}

export function checkOperatorInterface(params) {//验证(暂时未用)
    return request({
        url: "/account/accountInterface/insert.do?",
        method: 'post',
        data: params
    })
}

export function editOperatorInterface(params) {//编辑
    return request({
        url: "/account/accountInterface/update.do?",
        method: 'post',
        data: params
    })
}

export function deleteOperatorInterface(params) {//删除
    return request({
        url: "/account/accountInterface/del.do?",
        method: 'post',
        data: params
    })
}


// 操作日志 - 账号维度
export function getOperatorAccountOpLog(params) {
    return request({
        url: "/account/opLog/account.do?",
        method: 'post',
        data: params
    })
}

// 操作日志 - 接口维度
export function getOperatorInterfaceOpLog(params) {
    return request({
        url: "/account/opLog/interface.do?",
        method: 'post',
        data: params
    })
}




